<template>
  <div class="profile--settings--row row">
    <div class="columns small-3">
      <h4 class="block-title">
        {{ $t('PROFILE_SETTINGS.FORM.SMTP_SECTION.TITLE') }}
      </h4>
      <p>{{ $t('PROFILE_SETTINGS.FORM.SMTP_SECTION.NOTE') }}</p>
    </div>

    <div class="columns small-9 medium-5">
      <label for="profile-smtp-enabled">
        <input
          id="profile-smtp-enabled"
          v-model="smtpEnabled"
          type="checkbox"
        />
        {{ $t('PROFILE_SETTINGS.FORM.SMTP_SECTION.ENABLED') }}
      </label>

      <div v-if="smtpEnabled" class="smtp-fields">
        <woot-input
          v-model.trim="smtpAddress"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.ADDRESS')"
        />
        <woot-input
          v-model.number="smtpPort"
          type="number"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.PORT')"
        />
        <woot-input
          v-model.trim="smtpLogin"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.LOGIN')"
        />
        <woot-input
          v-model.trim="smtpPassword"
          type="password"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.PASSWORD')"
        />
        <woot-input
          v-model.trim="smtpDomain"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.DOMAIN')"
        />
        <woot-input
          v-model.trim="fromEmail"
          type="email"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.FROM_EMAIL')"
        />
        <woot-input
          v-model.trim="fromName"
          :label="$t('PROFILE_SETTINGS.FORM.SMTP.FROM_NAME')"
        />

        <label>
          <input v-model="smtpEnableStarttlsAuto" type="checkbox" />
          {{ $t('PROFILE_SETTINGS.FORM.SMTP.STARTTLS') }}
        </label>
        <label>
          <input v-model="smtpEnableSslTls" type="checkbox" />
          {{ $t('PROFILE_SETTINGS.FORM.SMTP.SSL_TLS') }}
        </label>

        <label>
          {{ $t('PROFILE_SETTINGS.FORM.SMTP.AUTHENTICATION') }}
          <select v-model="smtpAuthentication">
            <option value="plain">plain</option>
            <option value="login">login</option>
            <option value="cram-md5">cram-md5</option>
            <option value="xoauth">xoauth</option>
            <option value="xoauth2">xoauth2</option>
            <option value="ntlm">ntlm</option>
            <option value="gssapi">gssapi</option>
          </select>
        </label>

        <label>
          {{ $t('PROFILE_SETTINGS.FORM.SMTP.OPENSSL_VERIFY_MODE') }}
          <select v-model="smtpOpensslVerifyMode">
            <option value="none">none</option>
            <option value="peer">peer</option>
            <option value="client_once">client_once</option>
            <option value="fail_if_no_peer_cert">fail_if_no_peer_cert</option>
          </select>
        </label>
      </div>

      <woot-button
        class="bg-primary"
        :is-loading="isUpdating"
        @click="updateSMTP"
      >
        {{ $t('PROFILE_SETTINGS.FORM.SMTP_SECTION.BTN_TEXT') }}
      </woot-button>
    </div>
  </div>
</template>

<script>
import authAPI from 'dashboard/api/auth';
import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  data() {
    return {
      isUpdating: false,
      smtpEnabled: false,
      smtpAddress: '',
      smtpPort: 587,
      smtpLogin: '',
      smtpPassword: '',
      smtpDomain: '',
      smtpEnableSslTls: false,
      smtpEnableStarttlsAuto: true,
      smtpOpensslVerifyMode: 'none',
      smtpAuthentication: 'login',
      fromEmail: '',
      fromName: '',
    };
  },
  mounted() {
    this.loadSMTP();
  },
  methods: {
    async loadSMTP() {
      try {
        const { data } = await authAPI.getProfileSMTPSettings();
        if (!data || !Object.keys(data).length) return;

        this.smtpEnabled = !!data.smtp_enabled;
        this.smtpAddress = data.smtp_address || '';
        this.smtpPort = data.smtp_port || 587;
        this.smtpLogin = data.smtp_login || '';
        this.smtpPassword = data.smtp_password || '';
        this.smtpDomain = data.smtp_domain || '';
        this.smtpEnableSslTls = !!data.smtp_enable_ssl_tls;
        this.smtpEnableStarttlsAuto = !!data.smtp_enable_starttls_auto;
        this.smtpOpensslVerifyMode = data.smtp_openssl_verify_mode || 'none';
        this.smtpAuthentication = data.smtp_authentication || 'login';
        this.fromEmail = data.from_email || '';
        this.fromName = data.from_name || '';
      } catch (_error) {
        this.showAlert(
          this.$t('PROFILE_SETTINGS.FORM.SMTP_SECTION.LOAD_ERROR')
        );
      }
    },

    async updateSMTP() {
      this.isUpdating = true;
      try {
        await authAPI.updateProfileSMTPSettings({
          smtp_enabled: this.smtpEnabled,
          smtp_address: this.smtpAddress,
          smtp_port: this.smtpPort,
          smtp_login: this.smtpLogin,
          smtp_password: this.smtpPassword,
          smtp_domain: this.smtpDomain,
          smtp_enable_ssl_tls: this.smtpEnableSslTls,
          smtp_enable_starttls_auto: this.smtpEnableStarttlsAuto,
          smtp_openssl_verify_mode: this.smtpOpensslVerifyMode,
          smtp_authentication: this.smtpAuthentication,
          from_email: this.fromEmail,
          from_name: this.fromName,
        });

        this.showAlert(
          this.$t('PROFILE_SETTINGS.FORM.SMTP_SECTION.UPDATE_SUCCESS')
        );
      } catch (error) {
        this.showAlert(
          error?.response?.data?.error ||
            this.$t('PROFILE_SETTINGS.FORM.SMTP_SECTION.UPDATE_ERROR')
        );
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>

<style scoped>
.smtp-fields {
  margin: var(--space-normal) 0;
}
</style>
